// ProfileInfoBadges.js
import { connect } from 'react-redux';

import ProfileInfoBadges from '../component/ProfileInfoBadges.jsx';

import getUserBadges from '../selector/getUserBadges.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  PUBLIC_BADGE_URL_PATH,
  PUBLIC_LEADERBOARD_URL_PATH,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { userId }) => {
  return {
    publicBadgeUrlPath: getRemoteConfigData(state, PUBLIC_BADGE_URL_PATH),
    publicLeaderboardUrlPath: getRemoteConfigData(
      state,
      PUBLIC_LEADERBOARD_URL_PATH
    ),
    badges: getUserBadges(state, userId, 'badges'),
  };
};

export default connect(mapStateToProps)(ProfileInfoBadges);
